import React from 'react';
export const navBarLinks = [
  {
    title: 'Home',
    href: '/'
  },
  {
    title: (
      <span>
        About <b>Ignite</b>
      </span>
    ),
    href: '/about-ignite'
  },
  {
    title: 'My Store',
    children: [
      {
        title: 'Store Summary',
        href: '/store-summary'
      },
      {
        title: 'My Staff',
        href: '/my-staff',
        permissions: {
          action: 'handle',
          subjectClass: 'staff'
        }
      }
    ]
  },
  {
    title: 'Orders',
    permissions: {
      action: 'order,read',
      subjectClass: 'stock'
    },
    children: [
      {
        title: 'New Order',
        href: '/order/new'
      },
      {
        title: 'My Orders',
        href: '/my-orders'
      }
    ]
  },
  {
    title: 'Rewards',
    permissions: {
      action: 'view,handle',
      subjectClass: 'objective_info,objective_performance,staff_rewards'
    },
    children: [
      {
        title: 'How to earn',
        href: '/how-to-earn',
        permissions: {
          action: 'view',
          subjectClass: 'objective_info,objective_performance'
        }
      },
      {
        title: 'Store Performances',
        href: '/store-performances',
        permissions: {
          action: 'view',
          subjectClass: 'objective_info,objective_performance'
        }
      },
      {
        title: 'Staff Rewards',
        href: '/staff-rewards',
        permissions: {
          action: 'handle',
          subjectClass: 'staff_rewards'
        }
      },
    ]
  },
  {
    title: 'Explore Blu',
    permissions: {
      action: 'view',
      subjectClass: 'vape_information'
    },
    className: 'navbarBlu',
    children: [
      {
        title: 'About Vaping',
        href: '/about-vaping'
      },
      {
        title: 'MyBlu™',
        href: '/myblu',
        trademark: 1
      },
      {
        title: 'Educating your customer',
        href: '/educating-your-customer'
      },
      {
        title: 'Elearning',
        href: '/elearning',
        permissions: {
          action: 'view',
          subjectClass: 'e_learning'
        }
      }
    ]
  },
  {
    title: 'Latest News',
    href: '/latest-news'
  },
  {
    title: 'Contact Us',
    href: '/contact-us'
  }
];

export const navBarLinksAdmin = [
  {
    title: 'Users',
    children: [
      {
        title: 'User Groups',
        href: '/admin/user-groups',
        permissions: {
          action: 'index',
          subjectClass: 'UserGroup'
        }
      },
      {
        title: 'Users',
        href: '/admin/users',
        permissions: {
          action: 'index',
          subjectClass: 'User'
        }
      }
    ]
  },
  {
    title: 'Outlets',
    permissions: {
      action: 'manage',
      subjectClass: 'Outlet'
    },
    children: [
      {
        title: 'Outlets',
        href: '/admin/outlets',
        permissions: {
          action: 'manage',
          subjectClass: 'Outlet'
        }
      },
      {
        title: 'Delink',
        href: '/admin/outlets/delink',
        permissions: {
          action: 'delink',
          subjectClass: 'Outlet'
        }
      }
    ]
  },
  {
    title: 'Groups',
    href: '/admin/groups',
    permissions: {
      action: 'handle',
      subjectClass: 'Group'
    }
  },
  {
    title: 'Notifications',
    href: '/admin/notifications',
    permissions: {
      action: 'index',
      subjectClass: 'Notification'
    }
  },
  {
    title: 'Data management',
    permissions: {
      action: 'index',
      subjectClass: 'DataManagement'
    },
    children: [
      {
        title: 'Data import',
        href: '/admin/data-management',
        permissions: {
          action: 'import',
          subjectClass: 'data'
        }
      },
      {
        title: 'Data export',
        href: '/admin/data-export',
        permissions: {
          action: 'export',
          subjectClass: 'data'
        }
      }
    ]
  },
  {
    title: 'Pages',
    href: '/admin/pages',
    permissions: {
      action: 'index',
      subjectClass: 'Page'
    }
  },
  {
    title: 'Products',
    permissions: {
      action: 'read',
      subjectClass: 'product_related_subjects'
    },
    children: [
      {
        title: 'Categories',
        href: '/admin/categories',
        permissions: {
          action: 'index',
          subjectClass: 'Category'
        }
      },
      {
        title: 'Brands',
        href: '/admin/brands',
        permissions: {
          action: 'index',
          subjectClass: 'Brand'
        }
      },
      {
        title: 'Products',
        href: '/admin/products',
        permissions: {
          action: 'index',
          subjectClass: 'Product'
        }
      }
    ]
  },
  {
    title: 'Promotions',
    permissions: {
      action: 'read',
      subjectClass: 'promotion_related_subjects'
    },
    children: [
      {
        title: 'Price promotions',
        href: '/admin/promotions',
        permissions: {
          action: 'index',
          subjectClass: 'Promotion'
        }
      },
      {
        title: 'Promotional banners',
        href: '/admin/promotional_banners',
        permissions: {
          action: 'index',
          subjectClass: 'PromotionalBanner'
        }
      },
      {
        title: 'Upsell popups',
        href: '/admin/upsell_popups',
        permissions: {
          action: 'index',
          subjectClass: 'UpsellPopup'
        }
      }
    ]
  },
  {
    title: 'Orders',
    permissions: {
      action: 'read',
      subjectClass: 'Order'
    },
    children: [
      {
        title: 'Order Limits',
        href: '/admin/order_limits',
        permissions: {
          action: 'manage',
          subjectClass: 'Order'
        }
      },
      {
        title: 'Orders',
        href: '/admin/orders',
        permissions: {
          action: 'index',
          subjectClass: 'Order'
        }
      }
    ]
  },
  {
    title: 'Incentives',
    permissions: {
      action: 'index',
      subjectClass: 'Incentive'
    },
    children: [
      {
        title: 'Sales Incentives',
        href: '/admin/sales_incentives',
      },
      {
        title: 'Stock It Incentives',
        href: '/admin/stock_it_incentives',
        permissions: {
          action: 'manage',
          subjectClass: 'StockItIncentive'
        }
      }
    ]
  },
  {
    title: 'Rewards',
    href: '/admin/rewards',
    permissions: {
      action: 'index',
      subjectClass: 'StaffRewardSetting'
    },
    children: [
      {
        title: 'Staff Reward Settings',
        href: '/admin/staff-reward/settings',
        permissions: {
          action: 'manage',
          subjectClass: 'StaffRewardSetting'
        }
      },
      {
        title: 'Staff Reward Redemptions',
        href: '/admin/staff-reward/redemptions',
        permissions: {
          action: 'index',
          subjectClass: 'Redemption'
        }
      },
      {
        title: 'Prizes',
        href: '/admin/prizes',
        permissions: {
          action: 'manage',
          subjectClass: 'StaffRewardSetting'
        }
      }
    ]
  },
  {
    title: 'Prepaid Cards',
    permissions: {
      action: 'index',
      subjectClass: 'PrepaidCards'
    },
    children: [
      {
        title: 'Prepaid Card Settings',
        href: '/admin/ppc/settings',
        permissions: {
          action: 'manage',
          subjectClass: 'PrepaidCardSetting'
        }
      },
      {
        title: 'Prepaid Card Management',
        href: '/admin/ppc/management',
        permissions: {
          action: 'index',
          subjectClass: 'PpcUser'
        }
      }
    ]
  },
  {
    title: 'Points',
    permissions: {
      action: 'index',
      subjectClass: 'ManagePoints'
    },
    children: [
      {
        title: 'Points transactions',
        href: '/admin/points-transactions',
        permissions: {
          action: 'index',
          subjectClass: 'PointTransaction'
        }
      },
      {
        title: 'Points expiry',
        href: '/admin/points-expiry',
        permissions: {
          action: 'manage',
          subjectClass: 'PointExpiry'
        }
      }
    ]
  },
  {
    title: 'Homepage',
    href: '/admin/homepage',
    permissions: {
      action: 'handle',
      subjectClass: 'home_page'
    }
  },
  {
    title: 'Assessments',
    href: '/admin/assessments',
    permissions: {
      action: 'read',
      subjectClass: 'assessment_related_subjects'
    }
  },
  {
    title: 'HO Accounts',
    href: '/admin/ho-accounts',
    permissions: {
      action: 'read',
      subjectClass: 'ho_account_related_subjects'
    }
  },
  {
    title: 'News',
    permissions: {
      action: 'index',
      subjectClass: 'new_categories_and_articles'
    },
    children: [
      {
        title: 'Categories',
        href: '/admin/news/categories',
        permissions: {
          action: 'index',
          subjectClass: 'new_categories_and_articles'
        }
      },
      {
        title: 'Articles',
        href: '/admin/news/articles',
        permissions: {
          action: 'index',
          subjectClass: 'new_categories_and_articles'
        }
      }
    ]
  },
  {
    title: 'Downloads',
    href: '/admin/downloads'
  },
  {
    title: 'Feature Toggles',
    href: '/admin/feature-toggles'
  },
  {
    title: 'Games',
    href: '/admin/games'
  }
];



// WEBPACK FOOTER //
// ./src/data/navbarLinks.js